module.exports = __webpack_public_path__ + "img/image_6_tablet.9dbb59a.jpg";